<style lang="scss" src="./main.scss"></style>
<template>
    <div class="main" v-report.pv="{f_module:'主页面'}">
        <LangSwitch v-if="!env.isWetv"></LangSwitch>
        <logo v-if="!env.isWeb"></logo>
        <RedeemContainer />
    </div>
</template>

<script type="text/ecmascript">
import env from '@tencent/vft-common/env';

import LangSwitch from 'src/components/lang-switch.vue';
import logo from 'src/components/mod-logo.vue';
import RedeemContainer from 'src/components/redeem-container.vue';

export default {
  name: 'app',
  data() {
    return {
      env,
    };
  },
  components: {
    logo,
    RedeemContainer,
    LangSwitch,
  },
};


</script>
